import { useRouteError, useNavigate, isRouteErrorResponse } from "react-router-dom";

import { Container, Box, useTheme } from '@mui/material';

import { FilledButton, InitiaTopAppBar, Typography } from '@initia-digital/component-library';

import { CONFIG } from '../config/const';
const { 
    DEFAULT_PAGE_CONFIG: PAGE_CONFIG,
    INITIA_SYSTEMS_APP_BAR_AND_PANEL_VISIBILITY_FILTER 
  } = CONFIG;

const ErrorPage = () => {
    // --------------------------------------------------
    const error = useRouteError() as Error;
    console.error(error);

    const theme = useTheme();
    const navigate = useNavigate();

    const shouldDisplayRouteError = isRouteErrorResponse(error);


    return (
        <Box display="flex" flexDirection="column" minHeight="100vh">
            <InitiaTopAppBar
                appName={PAGE_CONFIG.appName}
                appVersion={PAGE_CONFIG.appVersion}
                avatarButtonFilterFn={INITIA_SYSTEMS_APP_BAR_AND_PANEL_VISIBILITY_FILTER}
                homeImageTooltipLabel='Home'
                homeImageHandleClick={ () => navigate('/') }
            />
            <Container maxWidth="md">
                <Box id="error-page" display="flex" flexDirection="column" alignItems="center" justifyContent="center" flexGrow={1}>
                    <Box my="20px">
                        <Typography 
                            variant="h5" 
                            color={theme.palette.secondary.main} 
                            align="center"
                            fontSize="1.4rem"
                        >
                                Sorry, an unexpected error has occurred.
                        </Typography>
                    </Box>
                    <Box
                        display="flex"
                        flexDirection="column"
                        alignItems="center"
                        justifyContent="center"
                        my="20px"
                    >
                    {
                        shouldDisplayRouteError &&
                        <Typography variant="body1">
                            <i>{error.statusText || error.message}</i>
                        </Typography>
                    }
                    {
                        !shouldDisplayRouteError &&
                        <>                    
                            <Typography variant="body1" fontSize="1.4rem" align="center">
                                <strong>{error.name}</strong>
                            </Typography>
                            <Typography variant="body1" fontSize="0.8rem">
                                <i>{error.message}</i>
                            </Typography>
                        </>
                    }
                    </Box>
                    <Box display="flex" my="10px">
                        <FilledButton
                            backgroundColor={theme.palette.secondary.main}
                            color='white'
                            onClick={() => {
                                navigate('/')
                            }}
                            tooltipTitle={`Go to home`}
                        >
                            Home
                        </FilledButton>
                    </Box>
                </Box>
            </Container>
        </Box>
    );
}

export default ErrorPage;